/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountActivePremiumTrialQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
}>;


export type AccountActivePremiumTrialQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly premiumTrial: { readonly __typename?: 'AccountPremiumTrial', readonly expirationDate: CK.Timestamp } | null } | null };


export const AccountActivePremiumTrialDocument = gql`
    query AccountActivePremiumTrial($accountId: AccountId!) {
  account(id: $accountId) {
    id
    premiumTrial {
      expirationDate
    }
  }
}
    `;

/**
 * __useAccountActivePremiumTrialQuery__
 *
 * To run a query within a React component, call `useAccountActivePremiumTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountActivePremiumTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountActivePremiumTrialQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountActivePremiumTrialQuery(baseOptions: Apollo.QueryHookOptions<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables> & ({ variables: AccountActivePremiumTrialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>(AccountActivePremiumTrialDocument, options);
      }
export function useAccountActivePremiumTrialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>(AccountActivePremiumTrialDocument, options);
        }
export function useAccountActivePremiumTrialSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>(AccountActivePremiumTrialDocument, options);
        }
export type AccountActivePremiumTrialQueryHookResult = ReturnType<typeof useAccountActivePremiumTrialQuery>;
export type AccountActivePremiumTrialLazyQueryHookResult = ReturnType<typeof useAccountActivePremiumTrialLazyQuery>;
export type AccountActivePremiumTrialSuspenseQueryHookResult = ReturnType<typeof useAccountActivePremiumTrialSuspenseQuery>;
export type AccountActivePremiumTrialQueryResult = Apollo.QueryResult<AccountActivePremiumTrialQuery, AccountActivePremiumTrialQueryVariables>;